export const getTextWithCapitalizedFirstLetter = (text: string) => {
  return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
};

export const getDateAsIsoString = (date: string) => {
  let isoDateString = new Date(date.replace(/ /g, "T")).toISOString();
  if (isoDateString.length > 0) {
    isoDateString = isoDateString
      .replace("T", " ")
      .substring(0, isoDateString.length - 5);
  }
  return isoDateString;
};
